import {CommonModule} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';

import {APP_URLS, AppUrls} from 'libs/shared/environment/src/lib/tokens/url.token';
import {LoaderComponent} from '../loader/loader.component';

@Component({
    selector: 'app-admin-page-not-found',
    standalone: true,
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    imports: [CommonModule, LoaderComponent]
})
export class PageNotFoundComponent implements OnInit {
    constructor(@Inject(APP_URLS) private appUrls: AppUrls) {}

    ngOnInit(): void {
        // setTimeout is used to avoid a cyclic redirect in Firefox
        setTimeout(() => {
            window.location.href = `${this.appUrls.AUTH_SERVER_URL}/PageNotFound`;
        }, 250);
    }
}
